import { cn } from "../../../lib/utils";
import React from "react";

const BaseContainer: React.FC<any> = (props: any) => {
  const { children, styles, className } = props;

  return (
    <div
      className={cn(
        `
        md:w-full
        min-w-[95%]
        w-full
        mt-0 md:mt-6
        mx-4 md:mx-auto
        p-6
        rounded-sm
        border border-border
        bg-card
        animate-fade-in
      `,
        className
      )}
      {...styles}
    >
      <div>{children}</div>
    </div>
  );
};

export default BaseContainer;
